import { render, staticRenderFns } from "./ProductGalleryOverlay.vue?vue&type=template&id=179d50ee&scoped=true&"
import script from "./ProductGalleryOverlay.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleryOverlay.vue?vue&type=style&index=0&id=179d50ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d50ee",
  null
  
)

export default component.exports